import FinalizedAssignmentItem from "./FinalizedAssignmentItem";

export default class FinalizedAssignmentClientItem extends FinalizedAssignmentItem {
  static FieldsToShowInDataTable() {
    return [
      { label: "Selected", orderById: "", data: FinalizedAssignmentItem.getSelectedCellContent, minWidth: 20, rolekey: "project_finalizedassignmentselect" },
      { label: "Apollo Id", orderById: "AsSassieAsgnId", data: FinalizedAssignmentItem.idFunction },
      { label: "Project", orderById: "AsCfname", data: "AsCfname", minWidth: 200 },
      { label: "Project ID", orderById: "AsCfid", data: "AsCfid", minWidth: 60 },
      { label: "Location", orderById: "CuName", data: "CuName", minWidth: 250 },
      { label: "Client Fee Total", orderById: "FeeTotal", data: "FeeTotal", minWidth: 80 },
      { label: "Reimb. Total", orderById: "ReimbTotal", data: "ReimbTotal", minWidth: 80 },
      { label: "FW Office", orderById: "AsLdvname", data: "AsLdvname" },
      { label: "FW Fee", orderById: "AsFieldworkFeeWithSymbol", data: "AsFieldworkFeeWithSymbol", minWidth: 80 },
      { label: "Evaluator", orderById: "AsEvname", data: "AsEvname" },
      { label: "Status", orderById: "LgsDesc", data: "LgsDesc", minWidth: 70 },
      { label: "Completed On", orderById: "AsEvaluatorCompletedDateFormatted", data: "AsEvaluatorCompletedDateFormatted", minWidth: 90 },
      { label: "Country", orderById: "CuCountry", data: "CuCountry", minWidth: 55 },
    ];
  }
}
